// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Spot Orders — main content only (.so-*), no header/sidebar */

.so-desktopWrap {
  width: 100%;
  overflow: visible;
}

.so-page {
  width: 100%;
  max-width: 100%;
  padding: 0px;
  background: #ffffff00;
  box-sizing: border-box;
  overflow: visible;
}

body.light_theme .so-page {
  background: #ffffff;
}

.so-page *,
.so-page *::before,
.so-page *::after {
  box-sizing: border-box;
}

body .so-table tbody td.first_child_td span {
  font-size: 12px;
  font-weight: 400;
  color: #8E939C;
  display: block;
}

.so-page__title {
  margin: 0 0 28px;
  font-size: 24px;
  font-weight: 600;
  letter-spacing: -0.02em;
  color: #f0f0f0;
  line-height: 1.2;
}

body.light_theme .so-page__title {
  color: #101828;
}

/* Toolbar: filters left, download actions right (match Figma bar) */
.so-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 16px;
  margin-bottom: 0px;
  padding-bottom: 24px;
  border-bottom: 1px solid #f0f0f038;
  -webkit-font-smoothing: antialiased;
  overflow: visible;
}

body.light_theme .so-toolbar {
  border-bottom: 1px solid #f0f0f0;
}

.so-toolbar__left {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 24px;
  flex: 0 1 auto;
  min-width: 0;
  overflow-x: auto;
  overflow-y: visible;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  scrollbar-width: none;
  /* Firefox */
}

.so-toolbar__left::-webkit-scrollbar {
  display: none;
  /* WebKit */
}

.so-dd__portal {
  z-index: 100000;
  /* above header + Bootstrap modals when needed */
  pointer-events: auto;
  box-sizing: border-box;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
}

.so-dd__portal .so-dd__menu,
.so-dd__portal .so-dd__menu * {
  pointer-events: auto;
}

/* When menu is rendered in a portal, the old absolute positioning must be disabled. */
.so-dd__portal .so-dd__menu {
  position: relative;
  top: auto;
  left: -12px;
  z-index: auto;
}

.so-toolbar__right {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  margin-left: auto;
}

.so-toolbar--stack {
  flex-direction: column;
  align-items: stretch;
}

.so-toolbar--stack .so-toolbar__left,
.so-toolbar--stack .so-toolbar__right {
  width: 100%;
  justify-content: flex-start;
}

.so-toolbar--stack .so-toolbar__right {
  flex-wrap: wrap;
  margin-left: 0;
}

.so-toolbar--stack .so-dd,
.so-toolbar--stack .so-dateBlock {
  width: 100%;
  min-width: 0;
  max-width: none;
}

.so-toolbar--stack .so-dd__trigger,
.so-toolbar--stack .so-dateRow {
  width: 100%;
}

.so-toolbar--stack .so-dateRow {
  flex-wrap: nowrap;
  overflow-x: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding-bottom: 2px;
}

.so-toolbar--stack .so-dateRow::-webkit-scrollbar {
  display: none;
}

.so-toolbar--stack .so-dateCell {
  flex: 1 1 120px;
  min-width: 0;
  width: auto;
}

/* Custom dropdown — vertical panel + chevron (second-screen / Coin reference) */
.so-dd {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 0 0 auto;
  width: 100%;
  min-width: 192px;
  max-width: 192px;
}

.so-dd.is-open {
  z-index: 10060;
}

.so-dd__label {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #ececec;
  line-height: 1.25;
  letter-spacing: 0;
  cursor: pointer;
  margin: 0;
}

body.light_theme .so-dd__label {
  color: #374151;
}

.so-dd__trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  min-height: 36px;
  padding: 0 14px 0 16px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.35;
  color: #e7e7e7;
  background: #181a20;
  border: 1px solid #e9eaef26;
  border-radius: 6px;
  cursor: pointer;
  text-align: left;
  outline: none;
  transition: border-color 0.15s ease, box-shadow 0.15s ease;
}

body.light_theme .so-dd__trigger {
  color: #111827;
  background: #ffffff;
  border: 1px solid #E9EAEF;
}

/* .so-dd__trigger:hover {
  border-color: #c4ccd4;
} */

.so-dd__trigger:focus-visible {
  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.25);
}

.so-dd__trigger.is-open {
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
}

.so-dd__value {
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #d7d7d7;
}

body.light_theme .so-dd__value {
  color: #111827;
}

/* Muted placeholder style when used later */
.so-dd__value--placeholder {
  color: #94a3b8;
}

.so-dd__chevSvg {
  flex-shrink: 0;
  color: #4b5563;
  transition: transform 0.2s ease;
}

.so-dd__chevSvg--open {
  transform: rotate(180deg);
}

.so-dd {
  position: relative;
}

/* Open panel: horizontal tiles (reference — Contract / All + pair chips) */
.so-dd__menu {
  position: absolute;
  top: calc(100% + 6px);
  left: 0;
  z-index: 10070;
  margin: 0;
  padding: 0;
  background: #25282e;
}

body.light_theme .so-dd__menu {
  background: #ffffff;
}

.so-dd__menu--tiles {
  display: flex;
  flex-flow: row wrap;
  flex-direction: column;
  align-items: start;
  gap: 2px;
  padding: 12px;
  width: max-content;
  min-width: 100%;
  max-width: min(720px, calc(100vw - 48px));
  list-style: none;
  border: 1px solid #e0e0e026;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1), 0 2px 6px rgba(15, 23, 42, 0.06);
  overflow: visible;
}

body.light_theme .so-dd__menu--tiles {
  border: 1px solid #e0e0e0;
  background: #fff;
}

.so-dd__menu--inline {
  position: static;
  top: auto;
  left: auto;
  margin-top: 6px;
  width: 100%;
  max-width: none;
  max-height: 260px;
  overflow: auto;
}

.listing_left_outer ul li.so-dd__menuItem {
  flex: 0 0 auto;
  margin: 0;
  padding: 0;
  list-style: none;
  border: none;
  gap: 0px;
  width: 100%;
  display: block;
  border-radius: 0px;
}

.listing_left_outer ul.so-dd__menu--tiles {
  display: flex;
  margin-top: 0px;
  gap: 0px;
  padding: 0px;
  border-radius: 10px;
  overflow: hidden;
}

.listing_left_outer ul li .so-dd__option--tile {
  width: auto;
  min-width: 100%;
  justify-content: start;
  border: none;
  border-radius: 0px;
}

.so-dd__option--tile {
  display: inline-flex;
  align-items: center;
  min-height: 32px;
  padding: 0px;
  width: auto;
  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.2;
  color: #d6d6d6;
  background: none;
  text-align: center;
  white-space: nowrap;
  border: none;
  border-radius: 0px;
  cursor: pointer;
  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;
}

body.light_theme .so-dd__option--tile {
  color: #1f2937;
  background: none;
}

/* .so-dd__option--tile:hover,
.so-dd__option--tile:focus-visible {
  background: #fafafa;
  outline: none;
} */

/* .so-dd__option--tile.is-selected {
  background: #f5f5f5;
  border-color: #d0d7de;
  color: #111827;
  font-weight: 600;
} */

/* Searchable dropdown — search box sits above the option list */
.so-dd__search {
  padding: 0px 2px 3px;
  border-bottom: 1px solid rgba(0, 0, 0, .07);
}

.so-dd__searchInput {
  width: 100%;
  padding: 5px 10px;
  border: 1px solid rgba(0, 0, 0, .13);
  border-radius: 6px;
  font-size: 13px;
  outline: none;
  background: transparent;
  color: inherit;
}

.so-dd__searchInput:focus {
  border-color: var(--color-primary, #f0b90b);
}

.so-dd__noResults {
  padding: 10px 14px;
  font-size: 13px;
  color: #94a3b8;
  list-style: none;
}

/* Date range — visible text matches design; native picker overlay */
.so-dateBlock {
  display: flex;
  flex-direction: column;
  gap: 6px;
  flex: 0 0 auto;
  min-width: 0;
}

.so-dateBlock__label {
  font-size: 14px;
  font-weight: 500;
  color: #ececec;
  line-height: 1.2;
}

body.light_theme .so-dateBlock__label {
  color: #101828;
}

.so-dateRow {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 8px;
}

.so-dateArrow {
  flex-shrink: 0;
  font-size: 13px;
  color: #9ca3af;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1;
}

.so-dateCell {
  position: relative;
  flex: 0 0 auto;
  width: 132px;
  height: 36px;
  color: #e7e7e7;
  background: #181a20;
  border: 1px solid #e9eaef26;
  border-radius: 4px;
}

.stake-overview-header.border-bottom {
  border-bottom: 1px solid #dee2e000 !important;
}

body.light_theme .so-dateCell {
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

/* .so-dateCell:hover {
  border-color: #d4d4d4;
}

.so-dateCell:focus-within {
  border-color: #bdbdbd;
} */

.so-dateCell__text {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 400;
  color: #cfcfcf;
  pointer-events: none;
}

body.light_theme .so-dateCell__text {
  color: #1f2937;
}

.so-dateCell__native {
  position: absolute;
  inset: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  margin: 0;
  min-height: 36px;
  padding: 0;
  font-size: 16px;
  line-height: 40px;
  color: transparent;
  background: transparent;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  opacity: 0;
}

.so-dateCell__native::-webkit-calendar-picker-indicator {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
}

.so-dateCalBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 36px;
  padding: 0;
  flex-shrink: 0;
  color: #dddddd;
  background: #181a20;
  border: 1px solid #e0e0e02e;
  border-radius: 4px;
  cursor: pointer;
}

body.light_theme .so-dateCalBtn {
  color: #6b7280;
  background: #ffffff;
  border: 1px solid #e0e0e0;
}

/* .so-dateCalBtn:hover {
  color: #374151;
} */

/* Download / batch download */
.so-dlBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 36px;
  padding: 0 14px;
  font-family: inherit;
  font-size: 14px;
  font-weight: 400;
  color: #1f2937;
  background: #ffffff;
  border: 1px solid #E9EAEF;
  border-radius: 6px;
  cursor: pointer;
  white-space: nowrap;
}

/* .so-dlBtn:hover {
  border-color: #d4d4d4;
  background: #fafafa;
} */

.so-dlBtn__icon {
  flex-shrink: 0;
  color: #6b7280;
}

.so-tableWrap {
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  border-radius: 0;
}

.so-table {
  width: 100%;
  min-width: 1080px;
  border-collapse: collapse;
  font-size: 14px;
  font-weight: 500;
  color: #f0f0f0;
}

body.light_theme .so-table {
  color: #101828;
}

body .so-table thead th {
  padding: 12px 14px 14px;
  text-align: left;
  font-size: 12px;
  font-weight: 500;
  color: #98a2b3;
  letter-spacing: 0.02em;
  text-transform: none;
  border-bottom: 1px solid #eef2f63b;
  white-space: nowrap;
}

body.light_theme .so-table thead th {
  border-bottom: 1px solid #eef2f6;
}

.so-table thead th.so-table__th--right,
.so-table tbody td.so-table__td--right {
  text-align: right;
}

.so-table thead th.so-table__th--center,
.so-table tbody td.so-table__td--center {
  text-align: center;
}

body .so-table tbody td {
  padding: 14px;
  /* border-bottom: 1px solid #f2f4f7; */
  vertical-align: middle;
  color: #ebebeb;
  font-size: 14px;
  font-weight: 400;
}

body.light_theme .so-table tbody td {
  color: #101828;
}

.so-table tbody tr:last-child td {
  border-bottom: none;
}

/* Wider futures / open-orders grid; airy row spacing (screenshot-style) */
.so-table.so-table--air {
  min-width: 1280px;
}

.so-table.so-table--air tbody td {
  padding-top: 20px;
  padding-bottom: 20px;
  border-bottom: none;
}

.so-table.so-table--air tbody tr+tr td {
  box-shadow: none
}

/* .so-table.so-table--air .so-side--buy,
.so-table.so-table--air .so-side--sell {
  background: transparent;
  padding: 0;
  border-radius: 0;
  font-weight: 600;
} */

.so-table.so-table--air .so-side--buy {
  color: #008236;
}

.so-table.so-table--air .so-side--sell {
  color: #e7000b;
}

.so-table__td--muted {
  color: #98a3b8;
}

/* Text-style cancel (Open Orders Action column) */
.so-cancelLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 12px;
  border: none;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #E7000B;
  background: #FEF2F2;
  cursor: pointer;
}

.so-cancelLink:hover {
  text-decoration: underline;
}

/* Order History–style table: horizontal row dividers, wider grid */
/* .so-table.so-table--rowLines tbody td {
  border-bottom: 1px solid #f2f4f7;
} */

.so-table.so-table--rowLines tbody tr:last-child td {
  border-bottom: none;
}

.so-table.so-table--wide {
  min-width: 1320px;
}

/* Position Orders table width */
.so-table.so-table--positions {
  min-width: 1280px;
}

/* Options Open Orders — full grid fits one screen width (scoped; other tables unchanged) */
.so-optionsOpenOrdersPage {
  min-width: 0;
  max-width: 100%;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

@media (max-width: 1100px) {
  .so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  table-layout: fixed;
}

/* Column share of row (sums to 100%) */
.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--contract {
  width: 14%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--orderId {
  width: 8%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--time {
  width: 11%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--side {
  width: 6%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--price {
  width: 9%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--size {
  width: 7%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--unfilled {
  width: 7%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--fillPrice {
  width: 8%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--exec {
  width: 9%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--reduce {
  width: 7%;
}

.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--action {
  width: 8%;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders thead th {
  padding: 12px 4px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  vertical-align: bottom;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders tbody td {
  padding: 12px 4px;
  font-size: 12px;
  line-height: 1.35;
  overflow: hidden;
  word-wrap: break-word;
}

body .so-table colgroup {
  display: none;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--air tbody td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__strong {
  font-weight: 600;
  color: inherit;
}

body.light_theme .so-optionsOpenOrdersPage .so-optionsOpenOrders__strong {
  color: #101828;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders tbody td.so-optionsOpenOrders__contract {
  overflow: visible;
  word-break: break-word;
  white-space: normal;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__cellClip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdTime {
  white-space: normal;
  font-size: 11px;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__pill.so-side--buy,
.so-optionsOpenOrdersPage .so-optionsOpenOrders__pill.so-side--sell {
  padding: 2px 8px;
  font-size: 11px;
  font-weight: 500;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__thReduce,
.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdReduce {
  text-align: center;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__thAction,
.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdAction {
  text-align: center;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__reduceText {
  display: inline-block;
  color: inherit;
  font-weight: 400;
}

body.light_theme .so-optionsOpenOrdersPage .so-optionsOpenOrders__reduceText {
  color: #101828;
}

.so-optionsOpenOrdersPage .so-optionsOpenOrders__cancelBtn.so-cancelBtn {
  padding: 3px 10px;
  font-size: 11px;
  min-height: 0;
}

/* Options Order History — 13 cols, fit one screen (scoped) */
.so-optionsOrderHistoryPage {
  min-width: 0;
  max-width: 100%;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

@media (max-width: 1200px) {
  .so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  table-layout: fixed;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--contract {
  width: 7%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--created {
  width: 8%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--end {
  width: 8%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--side {
  width: 5%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--size {
  width: 6%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--avg {
  width: 8%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--orderPx {
  width: 7%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--filled {
  width: 5%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--fee {
  width: 7%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--exec {
  width: 6%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--reduce {
  width: 6%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--orderId {
  width: 8%;
}

.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--status {
  width: 9%;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory thead th {
  padding: 12px 3px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  vertical-align: bottom;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory tbody td {
  padding: 12px 3px;
  font-size: 12px;
  line-height: 1.3;
  overflow: hidden;
  word-wrap: break-word;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--air tbody td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistory__strong {
  font-weight: 600;
  color: inherit;
}

body.light_theme .so-optionsOrderHistoryPage .so-optionsOrderHistory__strong {
  color: #101828;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistory__cellTime {
  white-space: normal;
  font-size: 10px;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistory__cellClip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistory__sideCell {
  color: #98a2b3;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistory__tdReduce {
  text-align: center;
}

.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory tbody td.so-table__emptyWrap {
  padding: 48px 24px !important;
  text-align: center;
  vertical-align: middle;
  border-bottom: none !important;
}

/* Options Trade History — 8 cols, fit one screen (scoped) */
.so-optionsTradeHistoryPage {
  min-width: 0;
  max-width: 100%;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

@media (max-width: 900px) {
  .so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  table-layout: fixed;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--contract {
  width: 14%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--side {
  width: 10%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--size {
  width: 10%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--fill {
  width: 14%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--fee {
  width: 10%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--orderId {
  width: 14%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--tradeId {
  width: 14%;
}

.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--tradedAt {
  width: 14%;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory thead th {
  padding: 12px 6px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  white-space: normal;
  word-break: break-word;
  vertical-align: bottom;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory tbody td {
  padding: 14px 6px;
  font-size: 13px;
  line-height: 1.35;
  overflow: hidden;
  word-wrap: break-word;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--air tbody td {
  padding-top: 14px;
  padding-bottom: 14px;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistory__strong {
  font-weight: 600;
  color: inherit;
}

body.light_theme .so-optionsTradeHistoryPage .so-optionsTradeHistory__strong {
  color: #101828;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistory__pill.so-side--buy,
.so-optionsTradeHistoryPage .so-optionsTradeHistory__pill.so-side--sell {
  padding: 3px 10px;
  font-size: 12px;
  font-weight: 500;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistory__cellClip {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistory__cellTime {
  white-space: normal;
  font-size: 12px;
}

.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory tbody td.so-table__emptyWrap {
  text-align: center;
  vertical-align: middle;
  border-bottom: none !important;
}

/* Options Position History — 5 cols, fit one screen (scoped) */
.so-optionsPositionHistoryPage {
  min-width: 0;
  max-width: 100%;
}

.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell {
  display: block;
  width: 100%;
  max-width: 100%;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: visible;
}

@media (max-width: 640px) {
  .so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
}

.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  table-layout: fixed;
}

.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--time {
  width: 22%;
}

.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--symbol {
  width: 18%;
}

.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--pnl {
  width: 22%;
}

.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--source {
  width: 18%;
}

.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--side {
  width: 20%;
}

.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory thead th {
  padding: 12px 8px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.25;
  white-space: normal;
  vertical-align: bottom;
}

.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory tbody td {
  padding: 14px 8px;
  font-size: 13px;
  line-height: 1.35;
  overflow: hidden;
  word-wrap: break-word;
}

.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--air tbody td {
  padding-top: 14px;
  padding-bottom: 14px;
}

.so-optionsPositionHistoryPage .so-optionsPositionHistory__cellTime {
  white-space: normal;
  font-size: 12px;
}

/* .so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory tbody td.so-table__emptyWrap {
  padding: 48px 24px !important;
  text-align: center;
  vertical-align: middle;
  border-bottom: none !important;
} */

.so-table.so-table--positionHistory {
  min-width: 800px;
}

.so-tableWrap--positionHistory {
  min-height: 280px;
}

/* Futures position: Long (red on light pink) */
.so-side--long {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 3px 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 500;
  color: #E7000B;
  background: #fef2f2;
}

/* Position status e.g. Closed */
.so-badge--closed {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 999px;
  font-size: 16px;
}

/* Realized PnL positive */
.so-pnl--profit {
  color: #16C784;
  font-weight: 400;
}

.so-pnl--loss {
  color: #E7000B;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.so-spotPosAction--open {
  color: #00a63e;
  font-weight: 500;
}

.so-spotPosAction--close {
  color: #e7000b;
  font-weight: 500;
}

/* Trade History: contract + timestamp; green size */
.so-contractCell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
}

.so-contractCell__symbol {
  font-weight: 400;
  /* color: #10182C; */
  font-size: 14px;
  line-height: 1.3;
}

.so-contractCell__time {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.3;
}

.so-fillQty--pos {
  color: #16A34A;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.so-table.so-table--tradeHistory {
  min-width: 880px;
}

.so-mobileCard__stack {
  display: flex;
  flex-direction: column;
  align-items: end;
  gap: 4px;
  text-align: left;
}

span.so-mobileCard__stack.flex-direction-row {
  flex-direction: row;
  align-items: center !important;
}

span.so-mobileCard__stack.flex-direction-row span.so-table__td--muted.so-num {
  font-size: 12px;
  color: #101828;
  font-weight: 400;
}

.so-tableWrap--staking .so-pnl--profit {
  color: #008236;
  font-weight: 500;
  font-size: 13px;
}

span.so-mobileCard__stack.flex-direction-row span.so-table__td--muted.so-pnl--profit {
  font-weight: 500;
  font-size: 11px;
}

body .so-table tbody tdtd.onlgreen span.so-mobileCard__stack {
  text-align: left;
  align-items: normal;
  font-size: 13px;
  font-weight: 600;
}

.so-status {
  display: inline-block;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.2;
}

.so-status--completed {
  color: #008236;
  font-weight: 400;
  /* background-color: #F0FDF4; */
  font-size: 16px;
  /* min-width: 85px; */
  padding: 0px 0px;
  border-radius: 0px;
}

.so-status--pending {
  color: #d1aa67;
  font-weight: 400;
  font-size: 16px;
  text-align: center;
  padding: 0px;
  border-radius: 0px;
}

.so-lpStatus {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  white-space: nowrap;
}

.so-lpStatus--upcoming {
  color: #6B7280;
  background: #F3F4F6;
}

.so-lpStatus--live {
  color: #1E40AF;
}

.so-lpStatus--ended {
  color: #008236;
}

.so-lpAchieved {
  /* text-decoration: underline; */
  text-underline-offset: 3px;
}

.so-lpDateCell {
  line-height: 1.35;
}

.so-lpDateLbl {
  color: #6B7280;
  font-weight: 500;
}

.so-lpAmtWrap {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.so-lpStatus.so-lpStatus-ended {
  color: #D1AA67;
}

.so-lpProgress {
  display: flex;
  align-items: center;
  justify-content: start;
  gap: 10px;
}

.so-lpProgress__bar {
  position: relative;
  width: 120px;
  height: 6px;
  background: #F3F4F6;
  border-radius: 999px;
  overflow: hidden;
}

.so-lpProgress__fill {
  display: block;
  height: 100%;
  width: 0%;
  background: #6366F1;
  border-radius: 999px;
}

.so-lpProgress__pct {
  color: #6B7280;
  font-size: 14px;
  font-weight: 500;
  min-width: 34px;
  text-align: right;
}

.so-lpProgress--mobile {
  justify-content: flex-end;
}

.so-lpProgress--mobile .so-lpProgress__bar {
  width: 110px;
}

.so-badge-processing {
  color: #1E40AF;
  font-weight: 500;
  background-color: #DBEAFE;
  font-size: 12px;
  padding: 3px 10px;
  border-radius: 50px;
}

.so-table.so-table--air tbody td .bankbtn {
  font-size: 11px;
  font-weight: 400;
  background-color: #F3F4F6;
  border-radius: 4px;
  display: inline-block;
  padding: 4px 7px;
}

table tbody tr td span.so-badge-crypto {
  color: #8200DB;
  font-weight: 500;
  font-size: 12px;
  background-color: #F3E8FF;
  border: 1px solid #E9D4FF;
  padding: 3px 7px;
  border-radius: 50px;
}

.so-table.so-table--air tbody td strong {
  font-weight: 500;
}

.so-side--buy {
  color: #16A34A;
  font-weight: 400;
  /* background-color: #F0FDF4; */
  padding: 0px 0px;
  border-radius: 50px;
  font-size: 16px;
}

.so-side--sell {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border: none;
  border-radius: 999px;
  font-size: 16px;
  /* font-weight: 500; */
  color: #E7000B;
  /* background: #FEF2F2; */
  cursor: pointer;
}

.so-num {
  font-variant-numeric: tabular-nums;
}

.so-cancelBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px 0px;
  border: none;
  border-radius: 999px;
  font-size: 16px;
  /* font-weight: 500; */
  color: #E7000B;
  background: none;
  cursor: pointer;
}

.so-cancelBtn:hover {
  background: #fecdd3;
}

/* Pager under orders tables and mobile card lists (OrderTablePagination.js) */
.so-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px;
  margin: 18px 0 6px;
}

.so-pagination__num,
.so-pagination__nav {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  height: 32px;
  padding: 0 6px;
  border: 1px solid #eef2f63b;
  border-radius: 6px;
  background: none;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  color: #98a2b3;
  cursor: pointer;
}

.so-pagination__num:hover:not(.is-active),
.so-pagination__nav:hover:not(:disabled) {
  color: #f0f0f0;
  background: #ffffff12;
}

.so-pagination__num.is-active {
  border-color: #CBA763;
  color: #CBA763;
  font-weight: 600;
}

.so-pagination__nav:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.so-pagination__dots {
  padding: 0 2px;
  color: #98a2b3;
}

body.light_theme .so-pagination__num,
body.light_theme .so-pagination__nav {
  border-color: #e4e7ec;
  color: #475467;
}

body.light_theme .so-pagination__num:hover:not(.is-active),
body.light_theme .so-pagination__nav:hover:not(:disabled) {
  color: #101828;
  background: #f2f4f7;
}

body.light_theme .so-pagination__num.is-active {
  border-color: #CBA763;
  color: #CBA763;
}

body.light_theme .so-pagination__dots {
  color: #475467;
}

/* Mobile — visibility toggled by global .order_history_mobile_view / .desktop_view2 in style.css */
.so-mobile {
  padding: 0px;
}

.so-mobile__title {
  margin: 0 0 20px;
  font-size: 22px;
  font-weight: 700;
  color: #101828;
}

.so-mobile__toolbar {
  margin: 10px 0px;
}

.so-subtabsWrap {
  position: relative;
}

.so-subtabs {
  display: flex;
  align-items: center;
  gap: 24px;
  padding: 10px 0 0;
  margin: 0 0 14px;
  border-bottom: none;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}

.so-subtabs::-webkit-scrollbar {
  display: none;
}

.so-subtabs__tab {
  position: relative;
  padding: 10px 0 7px;
  font-size: 16px;
  font-weight: 500;
  color: #667085;
  text-decoration: none;
  white-space: nowrap;
  background: none;
  border: 0;
  cursor: pointer;
}

.so-subtabs__tab:hover {
  color: #f1f1f1;
}

body.light_theme .so-subtabs__tab:hover {
  color: #101828;
}

.so-subtabs__tab.is-active {
  color: #f1f1f1;
}

body.light_theme .so-subtabs__tab.is-active {
  color: #101828;
}

.so-subtabs__tab.is-active::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  right: 0px;
  width: 18px;
  height: 4px;
  background: #d1aa67;
  border-radius: 0px;
  margin: 0 auto;
}

/* Subtabs scroll arrows (mobile only) */
.so-subtabsArrow {
  display: none;
}

.so-mobileFiltersBar {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.so-filterIconBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px;
  padding: 0px;
  border: none;
  background: none;
  color: #f7f7f7;
}

body.light_theme .so-filterIconBtn {
  color: #101828;
}

.so-filterIconBtn i {
  font-size: 20px;
}

.so-filtersModal .modal-body .so-toolbar {
  margin: 0;
}

.so-filtersModal--filters .so-toolbar__right {
  display: none !important;
}

.so-filtersModal .modal-body .so-toolbar__left {
  width: 100%;
}

.so-filtersModal .modal-body .so-dlBtn {
  width: 100%;
  justify-content: center;
}

.so-filtersModal__footer {
  display: flex;
  gap: 10px;
}

.so-filtersModal__footer .btn {
  flex: 1 1;
}

body.light_theme .so-filtersModal .modal-content {
  background: #ffffffcc;
  color: #101828;
}

.so-filtersModal .modal-content {
  background: #1e232985;
  color: #eaecef;
}

body.light_theme .so-filtersModal .modal-header {
  border-bottom-color: #eef2f6;
}

.so-filtersModal .modal-header {
  border-bottom-color: #2b3139;
}

body.light_theme .so-filtersModal .modal-title {
  color: #101828;
}

.so-filtersModal .modal-title {
  color: #eaecef;
}

.so-mobileCard {
  margin-bottom: 24px;
}

.so-mobileCard__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding: 5px 0;
  font-size: 16px;
  color: #000;
}

.so-mobileCard__row span:first-child {
  color: #000000;
  font-weight: 400;
}

.so-mobileCard__row span:last-child {
  text-align: right;
}

.so-mobileCard__actions {
  margin-top: 0px;
  padding-top: 0px;
  text-align: center;
}

.so-mobileCard__actions.so-mobileCard__actions--split {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
  padding: 5px 0px;
}

.so-mobileCard__statusLabel {
  font-size: 15px;
  color: #707a8a;
}

/* Staking orders — CTA + empty state (no-data.svg) */
.so-goStakingBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 36px;
  padding: 0 18px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  border: 1px solid #ededed0f;
  background: #ededed2e;
  color: #ffffff;
  text-decoration: none;
  border-radius: 6px;
  transition: background-color 0.15s ease, border-color 0.15s ease;
}

body.light_theme .so-goStakingBtn {
  color: #101828;
  background: #ededed;
  border: 1px solid #d0d7de;
}

.so-goStakingBtn:hover {
  opacity: 0.9;
  color: #ffffff;
}

.so-stkActionCell {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.so-stkActionBtn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 28px;
  padding: 0 12px;
  font-family: inherit;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  text-decoration: none;
  background: rgb(255 255 255 / 10%);
  border: 1px solid rgb(208 215 222 / 10%);
  border-radius: 6px;
  cursor: pointer;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}


body .so-table tbody td .so-stakeType {
  font-size: 14px;
}

body.light_theme .so-stkActionBtn {
  color: #101828;
  background: #ffffff;
  border: 1px solid #d0d7de;
}

.so-stkActionBtn:hover:not(:disabled) {
  opacity: 0.8;
}

.so-stkActionBtn--redeem {
  color: #ffffff;
}

/* .so-stkActionBtn--redeem:hover:not(:disabled) {
  background: #fff1f2;
} */

.so-stkActionBtn--cancel {
  color: #ffffff;
}

/* .so-stkActionBtn--cancel:hover:not(:disabled) {
  background: #fffbeb;
} */

.so-stkActionBtn--view {
  gap: 4px;
}

.so-stkActionBtn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.so-stkHistRow--expandable {
  cursor: pointer;
  transition: background-color 0.15s ease;
}

.so-stkHistRow--expandable:hover {
  background: #fafafa;
}

.so-stkHistRow--expanded {
  background: #fafafa;
}

.so-stkHistType {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}

.so-stkHistTypeCell {
  width: 140px;
}

.so-stkHistType__arrow {
  font-size: 16px;
  color: #848e9c;
  flex-shrink: 0;
  margin-left: auto;
}

.so-stkHistExpandRow td {
  padding: 14px 16px 16px !important;
  background: #fafafa;
  border-bottom: 1px solid #f0f0f0 !important;
  vertical-align: middle;
}

.so-stkHistTopUpHeaderRow td {
  padding: 10px 14px 6px !important;
  background: #fafafa;
  border-bottom: none !important;
}

.so-stkHistTopUpHeaderRow .so-stkTopUpHistory__title {
  display: block;
  padding: 0;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 12px;
  font-weight: 600;
  color: #848e9c;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.so-stkHistTopUpRow td {
  padding: 14px !important;
  background: #fafafa;
  vertical-align: middle !important;
  border-bottom: 1px solid #f0f0f0 !important;
}

.so-stkHistTopUpRow:last-of-type td {
  border-bottom: 1px solid #f0f0f0 !important;
  padding-bottom: 16px !important;
}

.so-stkTopUpHistory {
  background: #fff;
  border: 1px solid #eaecef;
  border-radius: 8px;
  overflow: hidden;
}

.so-stkTopUpHistory__title {
  padding: 12px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #1e2329;
  border-bottom: 1px solid #f0f0f0;
  background: #f9fafb;
}

.so-stkTopUpHistory__card {
  padding: 4px 0;
  border-bottom: 1px solid #f0f0f0;
}

.so-stkTopUpHistory__card:last-child {
  border-bottom: none;
}

.so-stkTopUpHistory--mobile {
  margin-top: 12px;
}

.so-stkHistMobileCard--expandable .so-stkHistMobileType--clickable {
  cursor: pointer;
}

.so-stakingCoin {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.so-stakingCoin__icon {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
}

.so-stakeProtocol {
  color: #00a63e;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
}

.so-stakeType {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0px;
  border-radius: 999px;
  font-size: 16px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
}

.so-stakeType--flexible {
  color: #1f9e5e;
}

.so-stakeType--locked {
  color: #b45309;
}

.so-tableWrap--staking {
  min-height: 320px;
}

.so-table.so-table--staking {
  min-width: 860px;
}

.so-table.so-table--convert {
  min-width: 920px;
}

.so-convertSpend {
  color: #EF4444;
  font-weight: 400;
}

.so-convertReceive {
  color: #10B981;
  font-weight: 400;
}

.so-table.so-table--copyTrading {
  min-width: 1280px;
}

.so-tableWrap--copyTrading {
  min-height: 300px;
}

.so-copyExitCell {
  display: flex;
  align-items: flex-end;
  gap: 2px;
}

.so-table.so-table--staking tbody td.so-table__emptyWrap,
.so-table.so-table--convert tbody td.so-table__emptyWrap,
.so-table.so-table--copyTrading tbody td.so-table__emptyWrap,
.so-table.so-table--wide tbody td.so-table__emptyWrap {
  padding: 48px 24px !important;
  text-align: center;
  vertical-align: middle;
  border-bottom: none !important;
}

.so-emptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 260px;
  padding: 16px 0;
}

.so-emptyState--mobile {
  min-height: 220px;
  margin-top: 8px;
  padding: 32px 16px 48px;
  border-radius: 12px;
}

.so-emptyState__img {
  display: block;
  width: 120px;
  height: auto;
  max-height: 160px;
  object-fit: contain;
  filter: invert(1);
}

body.light_theme .so-emptyState__img {
  filter: invert(0);
}

.so-emptyState__caption {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #98a2b3;
}

@media (max-width: 1440px) {

  .so-toolbar .so-toolbar__left {
    width: 70%;
    overflow: scroll;
  }

}


@media (max-width: 1200px) {

  .so-toolbar--stack .so-toolbar__left,
  .so-toolbar--stack .so-toolbar__right {
    flex-wrap: wrap;
  }


  .so-stakeType {
    font-size: 13px;
  }

  .so-mobileCard__statusLabel {
    font-size: 13px;
  }

  .so-toolbar__left {
    gap: 12px;
  }

  .so-toolbar .so-toolbar__left {
    width: 100%;
  }

}

@media (max-width: 991px) {

  .so-mobile__title {
    display: none;
  }

  .orders-mrp__panel.orders-mrp__panel--light .so-mobileCard__statusLabel {
    font-size: 14px;
    color: #707a8a;
  }

  .orders-mrp__panel.orders-mrp__panel--light .so-cancelBtn {
    font-size: 14px;
  }

  .so-mobile .so-subtabs {
    padding: 0px 0 0;
    margin: 0 0 10px;
    border-bottom: none;
  }

  .so-mobile .so-subtabsWrap {
    padding: 0px;
    /* room for arrows */
  }

  .so-dd__menu--inline {
    position: absolute;
    top: 64px;
  }

  .so-mobile .so-subtabsArrow {
    display: inline-flex;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    align-items: center;
    justify-content: center;
    padding: 0px;
    height: 24px;
    border: none;
    border-radius: 0px !important;
    background: #fff;
    color: #101828;
    border-radius: 999px;
  }

  .so-mobile .so-subtabsArrow i {
    font-size: 18px;
    line-height: 1;
  }

  .so-mobile .so-subtabsArrow--left {
    left: 0;
  }

  .so-mobile .so-subtabsArrow--right {
    right: 0;
  }

  .so-mobile .so-subtabsArrow.is-hidden {
    display: none;
  }

  .so-mobile {
    margin-top: -12px;
  }

  .so-dd__menu--inline {
    margin-top: 0px;
  }

}

@media (max-width:767px) {

  .so-stkActionBtn {
    padding: 0 10px;
    font-size: 12px;
  }

  .so-mobileCard .so-stkActionCell {
    flex-wrap: wrap;
    justify-content: end;
  }

  .so-cancelBtn {
    font-size: 13px;
  }

}


@media (max-width: 640px) {
  .so-page {
    padding: 20px 16px 32px;
  }

  .so-page__title {
    font-size: 26px;
  }

  .so-toolbar:not(.so-toolbar--stack) {
    flex-direction: column;
    align-items: stretch;
  }

  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__left,
  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {
    width: 100%;
  }

  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {
    justify-content: flex-start;
  }

  .so-dd,
  .so-dateBlock {
    width: 100%;
    min-width: 0;
  }

  .so-subtabs__tab {
    font-size: 15px;
  }

  .so-dd__trigger {
    width: 100%;
    min-width: 0;
  }

  .so-toolbar--stack .so-goStakingBtn {
    width: 100%;
    justify-content: center;
  }
}

/*
 * Profile \`/user_profile/orders/spot_*\`: global style.css switches table vs cards at 1367px
 * viewport, while the profile rail uses 992px — narrow desktop can hide both or show the wrong
 * column. Force open-orders / order-history / trade-history mobile cards at ≤991px so the
 * same React \`rows\` as the table are visible on phones.
 */
@media (max-width: 991.98px) {
  .dashboard_right .dashboard_listing_section2.Overview_mid .listing_left_outer.full_width.transaction_history_t.desktop_view2.so-desktopWrap {
    display: none !important;
  }

  .dashboard_right .dashboard_listing_section2.Overview_mid .order_history_mobile_view.so-mobile {
    display: block !important;
    width: 100%;
  }
}

/* —— Orders → Deposit History (same API rows as asset Deposit page) —— */
.so-depHist_actions {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  max-width: 100%;
  min-width: 0;
}

.so-depHist_actions--wrap {
  flex-wrap: wrap;
  justify-content: flex-end;
}

.so-depHist_trunc {
  min-width: 0;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.so-depHist_iconBtn {
  display: inline-flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 8px;
  border: 1px solid rgba(148, 163, 184, 0.45);
  background: #f8fafc;
  color: #334155;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
  padding: 0;
  line-height: 1;
}

.so-depHist_iconBtn:hover {
  background: #eef2ff;
  border-color: rgba(99, 102, 241, 0.55);
  color: #3730a3;
}

.so-depHist_iconBtn--link {
  text-decoration: none;
}

.so-depHist_badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 6px 10px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 700;
  border: 1px solid transparent;
  white-space: nowrap;
  line-height: 1;
  text-transform: capitalize;
}

.so-depHist_badge.is-success {
  background: #ecfdf3;
  border-color: #a7f3d0;
  color: #067647;
}

.so-depHist_badge.is-pending {
  background: #fffbeb;
  border-color: #fde68a;
  color: #92400e;
}

.so-depHist_badge.is-danger {
  background: #fef2f2;
  border-color: #fecaca;
  color: #b42318;
}

.so-depHist_badge.is-info {
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}

.so-depHist_badge.is-neutral {
  background: #f1f5f9;
  border-color: #e2e8f0;
  color: #334155;
}

body:not(.light_theme) .so-depHist_iconBtn {
  background: #1f2937;
  border-color: rgba(148, 163, 184, 0.35);
  color: #e2e8f0;
}

body:not(.light_theme) .so-depHist_iconBtn:hover {
  background: rgba(59, 130, 246, 0.18);
  border-color: rgba(59, 130, 246, 0.45);
  color: #bfdbfe;
}

body:not(.light_theme) .so-depHist_badge.is-neutral {
  background: rgba(148, 163, 184, 0.12);
  border-color: rgba(148, 163, 184, 0.22);
  color: #e2e8f0;
}

body:not(.light_theme) .so-depHist_badge.is-success {
  background: rgba(16, 185, 129, 0.15);
  border-color: rgba(16, 185, 129, 0.35);
  color: #6ee7b7;
}

body:not(.light_theme) .so-depHist_badge.is-pending {
  background: rgba(245, 158, 11, 0.15);
  border-color: rgba(245, 158, 11, 0.35);
  color: #fcd34d;
}

body:not(.light_theme) .so-depHist_badge.is-danger {
  background: rgba(239, 68, 68, 0.15);
  border-color: rgba(239, 68, 68, 0.35);
  color: #fca5a5;
}

body:not(.light_theme) .so-depHist_badge.is-info {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.35);
  color: #93c5fd;
}

.so-filtersModal .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%);
}

body.light_theme .so-filtersModal .btn-close {
  filter: none;
}

.so-filtersModal .funding-account__check {
  color: #EAECEF;
}

body.light_theme .so-filtersModal .funding-account__check {
  color: #4A5565;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/SpotOrders/spotOrders.css"],"names":[],"mappings":"AAAA,+DAA+D;;AAE/D;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,iBAAiB;EACjB,qBAAqB;EACrB,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,kCAAkC;EAClC,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;EACjC,8BAA8B;EAC9B,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gDAAgD;EAChD,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;EACjC,4BAA4B;AAC9B;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA,sFAAsF;AACtF;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA,gFAAgF;AAChF;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH;EACE,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,cAAc;EACd,SAAS;EACT,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,yCAAyC;EACzC,gBAAgB;EAChB,2BAA2B;EAC3B,mBAAmB;EACnB,8EAA8E;EAC9E,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,eAAe;EACf,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kFAAkF;AACpF;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;;;GAIG;;AAEH;;;;;GAKG;;AAEH,gEAAgE;AAChE;EACE,oBAAoB;EACpB,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,cAAc;EACd,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,yBAAiB;UAAjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;;GAMG;;AAEH;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;GAEG;;AAEH,8BAA8B;AAC9B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,YAAY;EACZ,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,oBAAoB;EACpB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,0EAA0E;AAC1E;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE;AACF;;AAEA;;;;;;GAMG;;AAEH;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kDAAkD;AAClD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mEAAmE;AACnE;;GAEG;;AAEH;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,iBAAiB;AACnB;;AAEA,2FAA2F;AAC3F;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA,6DAA6D;AAC7D;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,4DAA4D;AAC5D;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA,+DAA+D;AAC/D;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;IAChB,iCAAiC;IACjC,8BAA8B;EAChC;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;;;;GAKG;;AAEH;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA,gCAAgC;AAChC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,kBAAkB;AACpB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,cAAc;EACd,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mGAAmG;AACnG;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,UAAU;EACV,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,wCAAwC;AACxC;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,qDAAqD;AACrD;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;EACd,qBAAqB;EACrB,kBAAkB;EAClB,gEAAgE;AAClE;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;EACrB,kCAAkC;EAClC,wCAAwC;EACxC,kBAAkB;EAClB,eAAe;EACf,kFAAkF;AACpF;;;AAGA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,cAAc;AAChB;;AAEA;;GAEG;;AAEH;EACE,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;EAClC,mBAAmB;EACnB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;EACjC,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;AAC7C;;AAEA;EACE,2CAA2C;EAC3C,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;AAEA;;;;EAIE,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE;IACE,UAAU;IACV,gBAAgB;EAClB;;AAEF;;;AAGA;;EAEE;;IAEE,eAAe;EACjB;;;EAGA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,WAAW;EACb;;AAEF;;AAEA;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,oBAAoB;EACtB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,6BAA6B;IAC7B,gBAAgB;IAChB,cAAc;IACd,oBAAoB;EACtB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,OAAO;EACT;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;AAEF;;AAEA;;EAEE;IACE,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;AAEF;;;AAGA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;;IAEE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;;;;;EAKE;AACF;EACE;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;IACzB,WAAW;EACb;AACF;;AAEA,yEAAyE;AACzE;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;EAC5E,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;EACvC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* Spot Orders — main content only (.so-*), no header/sidebar */\n\n.so-desktopWrap {\n  width: 100%;\n  overflow: visible;\n}\n\n.so-page {\n  width: 100%;\n  max-width: 100%;\n  padding: 0px;\n  background: #ffffff00;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\nbody.light_theme .so-page {\n  background: #ffffff;\n}\n\n.so-page *,\n.so-page *::before,\n.so-page *::after {\n  box-sizing: border-box;\n}\n\nbody .so-table tbody td.first_child_td span {\n  font-size: 12px;\n  font-weight: 400;\n  color: #8E939C;\n  display: block;\n}\n\n.so-page__title {\n  margin: 0 0 28px;\n  font-size: 24px;\n  font-weight: 600;\n  letter-spacing: -0.02em;\n  color: #f0f0f0;\n  line-height: 1.2;\n}\n\nbody.light_theme .so-page__title {\n  color: #101828;\n}\n\n/* Toolbar: filters left, download actions right (match Figma bar) */\n.so-toolbar {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: flex-end;\n  justify-content: flex-start;\n  gap: 16px;\n  margin-bottom: 0px;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #f0f0f038;\n  -webkit-font-smoothing: antialiased;\n  overflow: visible;\n}\n\nbody.light_theme .so-toolbar {\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.so-toolbar__left {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 24px;\n  flex: 0 1 auto;\n  min-width: 0;\n  overflow-x: auto;\n  overflow-y: visible;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior-x: contain;\n  scrollbar-width: none;\n  /* Firefox */\n}\n\n.so-toolbar__left::-webkit-scrollbar {\n  display: none;\n  /* WebKit */\n}\n\n.so-dd__portal {\n  z-index: 100000;\n  /* above header + Bootstrap modals when needed */\n  pointer-events: auto;\n  box-sizing: border-box;\n  overflow-x: hidden;\n  overflow-y: auto;\n  -webkit-overflow-scrolling: touch;\n  overscroll-behavior: contain;\n}\n\n.so-dd__portal .so-dd__menu,\n.so-dd__portal .so-dd__menu * {\n  pointer-events: auto;\n}\n\n/* When menu is rendered in a portal, the old absolute positioning must be disabled. */\n.so-dd__portal .so-dd__menu {\n  position: relative;\n  top: auto;\n  left: -12px;\n  z-index: auto;\n}\n\n.so-toolbar__right {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 10px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.so-toolbar--stack {\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.so-toolbar--stack .so-toolbar__left,\n.so-toolbar--stack .so-toolbar__right {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.so-toolbar--stack .so-toolbar__right {\n  flex-wrap: wrap;\n  margin-left: 0;\n}\n\n.so-toolbar--stack .so-dd,\n.so-toolbar--stack .so-dateBlock {\n  width: 100%;\n  min-width: 0;\n  max-width: none;\n}\n\n.so-toolbar--stack .so-dd__trigger,\n.so-toolbar--stack .so-dateRow {\n  width: 100%;\n}\n\n.so-toolbar--stack .so-dateRow {\n  flex-wrap: nowrap;\n  overflow-x: auto;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  padding-bottom: 2px;\n}\n\n.so-toolbar--stack .so-dateRow::-webkit-scrollbar {\n  display: none;\n}\n\n.so-toolbar--stack .so-dateCell {\n  flex: 1 1 120px;\n  min-width: 0;\n  width: auto;\n}\n\n/* Custom dropdown — vertical panel + chevron (second-screen / Coin reference) */\n.so-dd {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 0 0 auto;\n  width: 100%;\n  min-width: 192px;\n  max-width: 192px;\n}\n\n.so-dd.is-open {\n  z-index: 10060;\n}\n\n.so-dd__label {\n  display: block;\n  font-size: 14px;\n  font-weight: 500;\n  color: #ececec;\n  line-height: 1.25;\n  letter-spacing: 0;\n  cursor: pointer;\n  margin: 0;\n}\n\nbody.light_theme .so-dd__label {\n  color: #374151;\n}\n\n.so-dd__trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  width: 100%;\n  min-height: 36px;\n  padding: 0 14px 0 16px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.35;\n  color: #e7e7e7;\n  background: #181a20;\n  border: 1px solid #e9eaef26;\n  border-radius: 6px;\n  cursor: pointer;\n  text-align: left;\n  outline: none;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease;\n}\n\nbody.light_theme .so-dd__trigger {\n  color: #111827;\n  background: #ffffff;\n  border: 1px solid #E9EAEF;\n}\n\n/* .so-dd__trigger:hover {\n  border-color: #c4ccd4;\n} */\n\n.so-dd__trigger:focus-visible {\n  box-shadow: 0 0 0 3px rgba(156, 163, 175, 0.25);\n}\n\n.so-dd__trigger.is-open {\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n}\n\n.so-dd__value {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #d7d7d7;\n}\n\nbody.light_theme .so-dd__value {\n  color: #111827;\n}\n\n/* Muted placeholder style when used later */\n.so-dd__value--placeholder {\n  color: #94a3b8;\n}\n\n.so-dd__chevSvg {\n  flex-shrink: 0;\n  color: #4b5563;\n  transition: transform 0.2s ease;\n}\n\n.so-dd__chevSvg--open {\n  transform: rotate(180deg);\n}\n\n.so-dd {\n  position: relative;\n}\n\n/* Open panel: horizontal tiles (reference — Contract / All + pair chips) */\n.so-dd__menu {\n  position: absolute;\n  top: calc(100% + 6px);\n  left: 0;\n  z-index: 10070;\n  margin: 0;\n  padding: 0;\n  background: #25282e;\n}\n\nbody.light_theme .so-dd__menu {\n  background: #ffffff;\n}\n\n.so-dd__menu--tiles {\n  display: flex;\n  flex-flow: row wrap;\n  flex-direction: column;\n  align-items: start;\n  gap: 2px;\n  padding: 12px;\n  width: max-content;\n  min-width: 100%;\n  max-width: min(720px, calc(100vw - 48px));\n  list-style: none;\n  border: 1px solid #e0e0e026;\n  border-radius: 10px;\n  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.1), 0 2px 6px rgba(15, 23, 42, 0.06);\n  overflow: visible;\n}\n\nbody.light_theme .so-dd__menu--tiles {\n  border: 1px solid #e0e0e0;\n  background: #fff;\n}\n\n.so-dd__menu--inline {\n  position: static;\n  top: auto;\n  left: auto;\n  margin-top: 6px;\n  width: 100%;\n  max-width: none;\n  max-height: 260px;\n  overflow: auto;\n}\n\n.listing_left_outer ul li.so-dd__menuItem {\n  flex: 0 0 auto;\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  border: none;\n  gap: 0px;\n  width: 100%;\n  display: block;\n  border-radius: 0px;\n}\n\n.listing_left_outer ul.so-dd__menu--tiles {\n  display: flex;\n  margin-top: 0px;\n  gap: 0px;\n  padding: 0px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n\n.listing_left_outer ul li .so-dd__option--tile {\n  width: auto;\n  min-width: 100%;\n  justify-content: start;\n  border: none;\n  border-radius: 0px;\n}\n\n.so-dd__option--tile {\n  display: inline-flex;\n  align-items: center;\n  min-height: 32px;\n  padding: 0px;\n  width: auto;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1.2;\n  color: #d6d6d6;\n  background: none;\n  text-align: center;\n  white-space: nowrap;\n  border: none;\n  border-radius: 0px;\n  cursor: pointer;\n  transition: background-color 0.12s ease, border-color 0.12s ease, color 0.12s ease;\n}\n\nbody.light_theme .so-dd__option--tile {\n  color: #1f2937;\n  background: none;\n}\n\n/* .so-dd__option--tile:hover,\n.so-dd__option--tile:focus-visible {\n  background: #fafafa;\n  outline: none;\n} */\n\n/* .so-dd__option--tile.is-selected {\n  background: #f5f5f5;\n  border-color: #d0d7de;\n  color: #111827;\n  font-weight: 600;\n} */\n\n/* Searchable dropdown — search box sits above the option list */\n.so-dd__search {\n  padding: 0px 2px 3px;\n  border-bottom: 1px solid rgba(0, 0, 0, .07);\n}\n\n.so-dd__searchInput {\n  width: 100%;\n  padding: 5px 10px;\n  border: 1px solid rgba(0, 0, 0, .13);\n  border-radius: 6px;\n  font-size: 13px;\n  outline: none;\n  background: transparent;\n  color: inherit;\n}\n\n.so-dd__searchInput:focus {\n  border-color: var(--color-primary, #f0b90b);\n}\n\n.so-dd__noResults {\n  padding: 10px 14px;\n  font-size: 13px;\n  color: #94a3b8;\n  list-style: none;\n}\n\n/* Date range — visible text matches design; native picker overlay */\n.so-dateBlock {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  flex: 0 0 auto;\n  min-width: 0;\n}\n\n.so-dateBlock__label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #ececec;\n  line-height: 1.2;\n}\n\nbody.light_theme .so-dateBlock__label {\n  color: #101828;\n}\n\n.so-dateRow {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  gap: 8px;\n}\n\n.so-dateArrow {\n  flex-shrink: 0;\n  font-size: 13px;\n  color: #9ca3af;\n  user-select: none;\n  line-height: 1;\n}\n\n.so-dateCell {\n  position: relative;\n  flex: 0 0 auto;\n  width: 132px;\n  height: 36px;\n  color: #e7e7e7;\n  background: #181a20;\n  border: 1px solid #e9eaef26;\n  border-radius: 4px;\n}\n\n.stake-overview-header.border-bottom {\n  border-bottom: 1px solid #dee2e000 !important;\n}\n\nbody.light_theme .so-dateCell {\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n/* .so-dateCell:hover {\n  border-color: #d4d4d4;\n}\n\n.so-dateCell:focus-within {\n  border-color: #bdbdbd;\n} */\n\n.so-dateCell__text {\n  position: absolute;\n  inset: 0;\n  z-index: 1;\n  display: flex;\n  align-items: center;\n  padding: 0 12px;\n  font-size: 14px;\n  font-weight: 400;\n  color: #cfcfcf;\n  pointer-events: none;\n}\n\nbody.light_theme .so-dateCell__text {\n  color: #1f2937;\n}\n\n.so-dateCell__native {\n  position: absolute;\n  inset: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  min-height: 36px;\n  padding: 0;\n  font-size: 16px;\n  line-height: 40px;\n  color: transparent;\n  background: transparent;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.so-dateCell__native::-webkit-calendar-picker-indicator {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  margin: 0;\n  padding: 0;\n  cursor: pointer;\n  opacity: 0;\n}\n\n.so-dateCalBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 36px;\n  padding: 0;\n  flex-shrink: 0;\n  color: #dddddd;\n  background: #181a20;\n  border: 1px solid #e0e0e02e;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\nbody.light_theme .so-dateCalBtn {\n  color: #6b7280;\n  background: #ffffff;\n  border: 1px solid #e0e0e0;\n}\n\n/* .so-dateCalBtn:hover {\n  color: #374151;\n} */\n\n/* Download / batch download */\n.so-dlBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 36px;\n  padding: 0 14px;\n  font-family: inherit;\n  font-size: 14px;\n  font-weight: 400;\n  color: #1f2937;\n  background: #ffffff;\n  border: 1px solid #E9EAEF;\n  border-radius: 6px;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n/* .so-dlBtn:hover {\n  border-color: #d4d4d4;\n  background: #fafafa;\n} */\n\n.so-dlBtn__icon {\n  flex-shrink: 0;\n  color: #6b7280;\n}\n\n.so-tableWrap {\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  border-radius: 0;\n}\n\n.so-table {\n  width: 100%;\n  min-width: 1080px;\n  border-collapse: collapse;\n  font-size: 14px;\n  font-weight: 500;\n  color: #f0f0f0;\n}\n\nbody.light_theme .so-table {\n  color: #101828;\n}\n\nbody .so-table thead th {\n  padding: 12px 14px 14px;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 500;\n  color: #98a2b3;\n  letter-spacing: 0.02em;\n  text-transform: none;\n  border-bottom: 1px solid #eef2f63b;\n  white-space: nowrap;\n}\n\nbody.light_theme .so-table thead th {\n  border-bottom: 1px solid #eef2f6;\n}\n\n.so-table thead th.so-table__th--right,\n.so-table tbody td.so-table__td--right {\n  text-align: right;\n}\n\n.so-table thead th.so-table__th--center,\n.so-table tbody td.so-table__td--center {\n  text-align: center;\n}\n\nbody .so-table tbody td {\n  padding: 14px;\n  /* border-bottom: 1px solid #f2f4f7; */\n  vertical-align: middle;\n  color: #ebebeb;\n  font-size: 14px;\n  font-weight: 400;\n}\n\nbody.light_theme .so-table tbody td {\n  color: #101828;\n}\n\n.so-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n/* Wider futures / open-orders grid; airy row spacing (screenshot-style) */\n.so-table.so-table--air {\n  min-width: 1280px;\n}\n\n.so-table.so-table--air tbody td {\n  padding-top: 20px;\n  padding-bottom: 20px;\n  border-bottom: none;\n}\n\n.so-table.so-table--air tbody tr+tr td {\n  box-shadow: none\n}\n\n/* .so-table.so-table--air .so-side--buy,\n.so-table.so-table--air .so-side--sell {\n  background: transparent;\n  padding: 0;\n  border-radius: 0;\n  font-weight: 600;\n} */\n\n.so-table.so-table--air .so-side--buy {\n  color: #008236;\n}\n\n.so-table.so-table--air .so-side--sell {\n  color: #e7000b;\n}\n\n.so-table__td--muted {\n  color: #98a3b8;\n}\n\n/* Text-style cancel (Open Orders Action column) */\n.so-cancelLink {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2px 12px;\n  border: none;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #E7000B;\n  background: #FEF2F2;\n  cursor: pointer;\n}\n\n.so-cancelLink:hover {\n  text-decoration: underline;\n}\n\n/* Order History–style table: horizontal row dividers, wider grid */\n/* .so-table.so-table--rowLines tbody td {\n  border-bottom: 1px solid #f2f4f7;\n} */\n\n.so-table.so-table--rowLines tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.so-table.so-table--wide {\n  min-width: 1320px;\n}\n\n/* Position Orders table width */\n.so-table.so-table--positions {\n  min-width: 1280px;\n}\n\n/* Options Open Orders — full grid fits one screen width (scoped; other tables unchanged) */\n.so-optionsOpenOrdersPage {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n@media (max-width: 1100px) {\n  .so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\n/* Column share of row (sums to 100%) */\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--contract {\n  width: 14%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--orderId {\n  width: 8%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--time {\n  width: 11%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--side {\n  width: 6%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--price {\n  width: 9%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--size {\n  width: 7%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--unfilled {\n  width: 7%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--fillPrice {\n  width: 8%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--exec {\n  width: 9%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--reduce {\n  width: 7%;\n}\n\n.so-optionsOpenOrdersPage col.so-optionsOpenOrders__cw--action {\n  width: 8%;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders thead th {\n  padding: 12px 4px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.25;\n  vertical-align: bottom;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders tbody td {\n  padding: 12px 4px;\n  font-size: 12px;\n  line-height: 1.35;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n\nbody .so-table colgroup {\n  display: none;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--air tbody td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__strong {\n  font-weight: 600;\n  color: inherit;\n}\n\nbody.light_theme .so-optionsOpenOrdersPage .so-optionsOpenOrders__strong {\n  color: #101828;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrdersTableShell .so-table.so-table--optionsOpenOrders tbody td.so-optionsOpenOrders__contract {\n  overflow: visible;\n  word-break: break-word;\n  white-space: normal;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__cellClip {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdTime {\n  white-space: normal;\n  font-size: 11px;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__pill.so-side--buy,\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__pill.so-side--sell {\n  padding: 2px 8px;\n  font-size: 11px;\n  font-weight: 500;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__thReduce,\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdReduce {\n  text-align: center;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__thAction,\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__tdAction {\n  text-align: center;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__reduceText {\n  display: inline-block;\n  color: inherit;\n  font-weight: 400;\n}\n\nbody.light_theme .so-optionsOpenOrdersPage .so-optionsOpenOrders__reduceText {\n  color: #101828;\n}\n\n.so-optionsOpenOrdersPage .so-optionsOpenOrders__cancelBtn.so-cancelBtn {\n  padding: 3px 10px;\n  font-size: 11px;\n  min-height: 0;\n}\n\n/* Options Order History — 13 cols, fit one screen (scoped) */\n.so-optionsOrderHistoryPage {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n@media (max-width: 1200px) {\n  .so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--contract {\n  width: 7%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--created {\n  width: 8%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--end {\n  width: 8%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--side {\n  width: 5%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--size {\n  width: 6%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--avg {\n  width: 8%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--orderPx {\n  width: 7%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--filled {\n  width: 5%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--fee {\n  width: 7%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--exec {\n  width: 6%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--reduce {\n  width: 6%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--orderId {\n  width: 8%;\n}\n\n.so-optionsOrderHistoryPage col.so-optionsOrderHistory__cw--status {\n  width: 9%;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory thead th {\n  padding: 12px 3px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.2;\n  vertical-align: bottom;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory tbody td {\n  padding: 12px 3px;\n  font-size: 12px;\n  line-height: 1.3;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--air tbody td {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistory__strong {\n  font-weight: 600;\n  color: inherit;\n}\n\nbody.light_theme .so-optionsOrderHistoryPage .so-optionsOrderHistory__strong {\n  color: #101828;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistory__cellTime {\n  white-space: normal;\n  font-size: 10px;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistory__cellClip {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistory__sideCell {\n  color: #98a2b3;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistory__tdReduce {\n  text-align: center;\n}\n\n.so-optionsOrderHistoryPage .so-optionsOrderHistoryTableShell .so-table.so-table--optionsOrderHistory tbody td.so-table__emptyWrap {\n  padding: 48px 24px !important;\n  text-align: center;\n  vertical-align: middle;\n  border-bottom: none !important;\n}\n\n/* Options Trade History — 8 cols, fit one screen (scoped) */\n.so-optionsTradeHistoryPage {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n@media (max-width: 900px) {\n  .so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--contract {\n  width: 14%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--side {\n  width: 10%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--size {\n  width: 10%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--fill {\n  width: 14%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--fee {\n  width: 10%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--orderId {\n  width: 14%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--tradeId {\n  width: 14%;\n}\n\n.so-optionsTradeHistoryPage col.so-optionsTradeHistory__cw--tradedAt {\n  width: 14%;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory thead th {\n  padding: 12px 6px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.25;\n  white-space: normal;\n  word-break: break-word;\n  vertical-align: bottom;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory tbody td {\n  padding: 14px 6px;\n  font-size: 13px;\n  line-height: 1.35;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--air tbody td {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistory__strong {\n  font-weight: 600;\n  color: inherit;\n}\n\nbody.light_theme .so-optionsTradeHistoryPage .so-optionsTradeHistory__strong {\n  color: #101828;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistory__pill.so-side--buy,\n.so-optionsTradeHistoryPage .so-optionsTradeHistory__pill.so-side--sell {\n  padding: 3px 10px;\n  font-size: 12px;\n  font-weight: 500;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistory__cellClip {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistory__cellTime {\n  white-space: normal;\n  font-size: 12px;\n}\n\n.so-optionsTradeHistoryPage .so-optionsTradeHistoryTableShell .so-table.so-table--optionsTradeHistory tbody td.so-table__emptyWrap {\n  text-align: center;\n  vertical-align: middle;\n  border-bottom: none !important;\n}\n\n/* Options Position History — 5 cols, fit one screen (scoped) */\n.so-optionsPositionHistoryPage {\n  min-width: 0;\n  max-width: 100%;\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  min-width: 0;\n  overflow-x: hidden;\n  overflow-y: visible;\n}\n\n@media (max-width: 640px) {\n  .so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory {\n  width: 100%;\n  min-width: 0;\n  max-width: 100%;\n  table-layout: fixed;\n}\n\n.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--time {\n  width: 22%;\n}\n\n.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--symbol {\n  width: 18%;\n}\n\n.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--pnl {\n  width: 22%;\n}\n\n.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--source {\n  width: 18%;\n}\n\n.so-optionsPositionHistoryPage col.so-optionsPositionHistory__cw--side {\n  width: 20%;\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory thead th {\n  padding: 12px 8px 12px;\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.25;\n  white-space: normal;\n  vertical-align: bottom;\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory tbody td {\n  padding: 14px 8px;\n  font-size: 13px;\n  line-height: 1.35;\n  overflow: hidden;\n  word-wrap: break-word;\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--air tbody td {\n  padding-top: 14px;\n  padding-bottom: 14px;\n}\n\n.so-optionsPositionHistoryPage .so-optionsPositionHistory__cellTime {\n  white-space: normal;\n  font-size: 12px;\n}\n\n/* .so-optionsPositionHistoryPage .so-optionsPositionHistoryTableShell .so-table.so-table--optionsPositionHistory tbody td.so-table__emptyWrap {\n  padding: 48px 24px !important;\n  text-align: center;\n  vertical-align: middle;\n  border-bottom: none !important;\n} */\n\n.so-table.so-table--positionHistory {\n  min-width: 800px;\n}\n\n.so-tableWrap--positionHistory {\n  min-height: 280px;\n}\n\n/* Futures position: Long (red on light pink) */\n.so-side--long {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 3px 12px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 500;\n  color: #E7000B;\n  background: #fef2f2;\n}\n\n/* Position status e.g. Closed */\n.so-badge--closed {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border-radius: 999px;\n  font-size: 16px;\n}\n\n/* Realized PnL positive */\n.so-pnl--profit {\n  color: #16C784;\n  font-weight: 400;\n}\n\n.so-pnl--loss {\n  color: #E7000B;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.so-spotPosAction--open {\n  color: #00a63e;\n  font-weight: 500;\n}\n\n.so-spotPosAction--close {\n  color: #e7000b;\n  font-weight: 500;\n}\n\n/* Trade History: contract + timestamp; green size */\n.so-contractCell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 4px;\n}\n\n.so-contractCell__symbol {\n  font-weight: 400;\n  /* color: #10182C; */\n  font-size: 14px;\n  line-height: 1.3;\n}\n\n.so-contractCell__time {\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 1.3;\n}\n\n.so-fillQty--pos {\n  color: #16A34A;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.so-table.so-table--tradeHistory {\n  min-width: 880px;\n}\n\n.so-mobileCard__stack {\n  display: flex;\n  flex-direction: column;\n  align-items: end;\n  gap: 4px;\n  text-align: left;\n}\n\nspan.so-mobileCard__stack.flex-direction-row {\n  flex-direction: row;\n  align-items: center !important;\n}\n\nspan.so-mobileCard__stack.flex-direction-row span.so-table__td--muted.so-num {\n  font-size: 12px;\n  color: #101828;\n  font-weight: 400;\n}\n\n.so-tableWrap--staking .so-pnl--profit {\n  color: #008236;\n  font-weight: 500;\n  font-size: 13px;\n}\n\nspan.so-mobileCard__stack.flex-direction-row span.so-table__td--muted.so-pnl--profit {\n  font-weight: 500;\n  font-size: 11px;\n}\n\nbody .so-table tbody tdtd.onlgreen span.so-mobileCard__stack {\n  text-align: left;\n  align-items: normal;\n  font-size: 13px;\n  font-weight: 600;\n}\n\n.so-status {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n.so-status--completed {\n  color: #008236;\n  font-weight: 400;\n  /* background-color: #F0FDF4; */\n  font-size: 16px;\n  /* min-width: 85px; */\n  padding: 0px 0px;\n  border-radius: 0px;\n}\n\n.so-status--pending {\n  color: #d1aa67;\n  font-weight: 400;\n  font-size: 16px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 0px;\n}\n\n.so-lpStatus {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 400;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.so-lpStatus--upcoming {\n  color: #6B7280;\n  background: #F3F4F6;\n}\n\n.so-lpStatus--live {\n  color: #1E40AF;\n}\n\n.so-lpStatus--ended {\n  color: #008236;\n}\n\n.so-lpAchieved {\n  /* text-decoration: underline; */\n  text-underline-offset: 3px;\n}\n\n.so-lpDateCell {\n  line-height: 1.35;\n}\n\n.so-lpDateLbl {\n  color: #6B7280;\n  font-weight: 500;\n}\n\n.so-lpAmtWrap {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.so-lpStatus.so-lpStatus-ended {\n  color: #D1AA67;\n}\n\n.so-lpProgress {\n  display: flex;\n  align-items: center;\n  justify-content: start;\n  gap: 10px;\n}\n\n.so-lpProgress__bar {\n  position: relative;\n  width: 120px;\n  height: 6px;\n  background: #F3F4F6;\n  border-radius: 999px;\n  overflow: hidden;\n}\n\n.so-lpProgress__fill {\n  display: block;\n  height: 100%;\n  width: 0%;\n  background: #6366F1;\n  border-radius: 999px;\n}\n\n.so-lpProgress__pct {\n  color: #6B7280;\n  font-size: 14px;\n  font-weight: 500;\n  min-width: 34px;\n  text-align: right;\n}\n\n.so-lpProgress--mobile {\n  justify-content: flex-end;\n}\n\n.so-lpProgress--mobile .so-lpProgress__bar {\n  width: 110px;\n}\n\n.so-badge-processing {\n  color: #1E40AF;\n  font-weight: 500;\n  background-color: #DBEAFE;\n  font-size: 12px;\n  padding: 3px 10px;\n  border-radius: 50px;\n}\n\n.so-table.so-table--air tbody td .bankbtn {\n  font-size: 11px;\n  font-weight: 400;\n  background-color: #F3F4F6;\n  border-radius: 4px;\n  display: inline-block;\n  padding: 4px 7px;\n}\n\ntable tbody tr td span.so-badge-crypto {\n  color: #8200DB;\n  font-weight: 500;\n  font-size: 12px;\n  background-color: #F3E8FF;\n  border: 1px solid #E9D4FF;\n  padding: 3px 7px;\n  border-radius: 50px;\n}\n\n.so-table.so-table--air tbody td strong {\n  font-weight: 500;\n}\n\n.so-side--buy {\n  color: #16A34A;\n  font-weight: 400;\n  /* background-color: #F0FDF4; */\n  padding: 0px 0px;\n  border-radius: 50px;\n  font-size: 16px;\n}\n\n.so-side--sell {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border: none;\n  border-radius: 999px;\n  font-size: 16px;\n  /* font-weight: 500; */\n  color: #E7000B;\n  /* background: #FEF2F2; */\n  cursor: pointer;\n}\n\n.so-num {\n  font-variant-numeric: tabular-nums;\n}\n\n.so-cancelBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px 0px;\n  border: none;\n  border-radius: 999px;\n  font-size: 16px;\n  /* font-weight: 500; */\n  color: #E7000B;\n  background: none;\n  cursor: pointer;\n}\n\n.so-cancelBtn:hover {\n  background: #fecdd3;\n}\n\n/* Pager under orders tables and mobile card lists (OrderTablePagination.js) */\n.so-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin: 18px 0 6px;\n}\n\n.so-pagination__num,\n.so-pagination__nav {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  height: 32px;\n  padding: 0 6px;\n  border: 1px solid #eef2f63b;\n  border-radius: 6px;\n  background: none;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: 1;\n  color: #98a2b3;\n  cursor: pointer;\n}\n\n.so-pagination__num:hover:not(.is-active),\n.so-pagination__nav:hover:not(:disabled) {\n  color: #f0f0f0;\n  background: #ffffff12;\n}\n\n.so-pagination__num.is-active {\n  border-color: #CBA763;\n  color: #CBA763;\n  font-weight: 600;\n}\n\n.so-pagination__nav:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n.so-pagination__dots {\n  padding: 0 2px;\n  color: #98a2b3;\n}\n\nbody.light_theme .so-pagination__num,\nbody.light_theme .so-pagination__nav {\n  border-color: #e4e7ec;\n  color: #475467;\n}\n\nbody.light_theme .so-pagination__num:hover:not(.is-active),\nbody.light_theme .so-pagination__nav:hover:not(:disabled) {\n  color: #101828;\n  background: #f2f4f7;\n}\n\nbody.light_theme .so-pagination__num.is-active {\n  border-color: #CBA763;\n  color: #CBA763;\n}\n\nbody.light_theme .so-pagination__dots {\n  color: #475467;\n}\n\n/* Mobile — visibility toggled by global .order_history_mobile_view / .desktop_view2 in style.css */\n.so-mobile {\n  padding: 0px;\n}\n\n.so-mobile__title {\n  margin: 0 0 20px;\n  font-size: 22px;\n  font-weight: 700;\n  color: #101828;\n}\n\n.so-mobile__toolbar {\n  margin: 10px 0px;\n}\n\n.so-subtabsWrap {\n  position: relative;\n}\n\n.so-subtabs {\n  display: flex;\n  align-items: center;\n  gap: 24px;\n  padding: 10px 0 0;\n  margin: 0 0 14px;\n  border-bottom: none;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n  scrollbar-width: none;\n}\n\n.so-subtabs::-webkit-scrollbar {\n  display: none;\n}\n\n.so-subtabs__tab {\n  position: relative;\n  padding: 10px 0 7px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #667085;\n  text-decoration: none;\n  white-space: nowrap;\n  background: none;\n  border: 0;\n  cursor: pointer;\n}\n\n.so-subtabs__tab:hover {\n  color: #f1f1f1;\n}\n\nbody.light_theme .so-subtabs__tab:hover {\n  color: #101828;\n}\n\n.so-subtabs__tab.is-active {\n  color: #f1f1f1;\n}\n\nbody.light_theme .so-subtabs__tab.is-active {\n  color: #101828;\n}\n\n.so-subtabs__tab.is-active::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  right: 0px;\n  width: 18px;\n  height: 4px;\n  background: #d1aa67;\n  border-radius: 0px;\n  margin: 0 auto;\n}\n\n/* Subtabs scroll arrows (mobile only) */\n.so-subtabsArrow {\n  display: none;\n}\n\n.so-mobileFiltersBar {\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.so-filterIconBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 0px;\n  padding: 0px;\n  border: none;\n  background: none;\n  color: #f7f7f7;\n}\n\nbody.light_theme .so-filterIconBtn {\n  color: #101828;\n}\n\n.so-filterIconBtn i {\n  font-size: 20px;\n}\n\n.so-filtersModal .modal-body .so-toolbar {\n  margin: 0;\n}\n\n.so-filtersModal--filters .so-toolbar__right {\n  display: none !important;\n}\n\n.so-filtersModal .modal-body .so-toolbar__left {\n  width: 100%;\n}\n\n.so-filtersModal .modal-body .so-dlBtn {\n  width: 100%;\n  justify-content: center;\n}\n\n.so-filtersModal__footer {\n  display: flex;\n  gap: 10px;\n}\n\n.so-filtersModal__footer .btn {\n  flex: 1 1 0%;\n}\n\nbody.light_theme .so-filtersModal .modal-content {\n  background: #ffffffcc;\n  color: #101828;\n}\n\n.so-filtersModal .modal-content {\n  background: #1e232985;\n  color: #eaecef;\n}\n\nbody.light_theme .so-filtersModal .modal-header {\n  border-bottom-color: #eef2f6;\n}\n\n.so-filtersModal .modal-header {\n  border-bottom-color: #2b3139;\n}\n\nbody.light_theme .so-filtersModal .modal-title {\n  color: #101828;\n}\n\n.so-filtersModal .modal-title {\n  color: #eaecef;\n}\n\n.so-mobileCard {\n  margin-bottom: 24px;\n}\n\n.so-mobileCard__row {\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 5px 0;\n  font-size: 16px;\n  color: #000;\n}\n\n.so-mobileCard__row span:first-child {\n  color: #000000;\n  font-weight: 400;\n}\n\n.so-mobileCard__row span:last-child {\n  text-align: right;\n}\n\n.so-mobileCard__actions {\n  margin-top: 0px;\n  padding-top: 0px;\n  text-align: center;\n}\n\n.so-mobileCard__actions.so-mobileCard__actions--split {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  text-align: left;\n  padding: 5px 0px;\n}\n\n.so-mobileCard__statusLabel {\n  font-size: 15px;\n  color: #707a8a;\n}\n\n/* Staking orders — CTA + empty state (no-data.svg) */\n.so-goStakingBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 36px;\n  padding: 0 18px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  border: 1px solid #ededed0f;\n  background: #ededed2e;\n  color: #ffffff;\n  text-decoration: none;\n  border-radius: 6px;\n  transition: background-color 0.15s ease, border-color 0.15s ease;\n}\n\nbody.light_theme .so-goStakingBtn {\n  color: #101828;\n  background: #ededed;\n  border: 1px solid #d0d7de;\n}\n\n.so-goStakingBtn:hover {\n  opacity: 0.9;\n  color: #ffffff;\n}\n\n.so-stkActionCell {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.so-stkActionBtn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 28px;\n  padding: 0 12px;\n  font-family: inherit;\n  font-size: 13px;\n  font-weight: 500;\n  color: #ffffff;\n  text-decoration: none;\n  background: rgb(255 255 255 / 10%);\n  border: 1px solid rgb(208 215 222 / 10%);\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n\nbody .so-table tbody td .so-stakeType {\n  font-size: 14px;\n}\n\nbody.light_theme .so-stkActionBtn {\n  color: #101828;\n  background: #ffffff;\n  border: 1px solid #d0d7de;\n}\n\n.so-stkActionBtn:hover:not(:disabled) {\n  opacity: 0.8;\n}\n\n.so-stkActionBtn--redeem {\n  color: #ffffff;\n}\n\n/* .so-stkActionBtn--redeem:hover:not(:disabled) {\n  background: #fff1f2;\n} */\n\n.so-stkActionBtn--cancel {\n  color: #ffffff;\n}\n\n/* .so-stkActionBtn--cancel:hover:not(:disabled) {\n  background: #fffbeb;\n} */\n\n.so-stkActionBtn--view {\n  gap: 4px;\n}\n\n.so-stkActionBtn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.so-stkHistRow--expandable {\n  cursor: pointer;\n  transition: background-color 0.15s ease;\n}\n\n.so-stkHistRow--expandable:hover {\n  background: #fafafa;\n}\n\n.so-stkHistRow--expanded {\n  background: #fafafa;\n}\n\n.so-stkHistType {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  gap: 8px;\n}\n\n.so-stkHistTypeCell {\n  width: 140px;\n}\n\n.so-stkHistType__arrow {\n  font-size: 16px;\n  color: #848e9c;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.so-stkHistExpandRow td {\n  padding: 14px 16px 16px !important;\n  background: #fafafa;\n  border-bottom: 1px solid #f0f0f0 !important;\n  vertical-align: middle;\n}\n\n.so-stkHistTopUpHeaderRow td {\n  padding: 10px 14px 6px !important;\n  background: #fafafa;\n  border-bottom: none !important;\n}\n\n.so-stkHistTopUpHeaderRow .so-stkTopUpHistory__title {\n  display: block;\n  padding: 0;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 12px;\n  font-weight: 600;\n  color: #848e9c;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n\n.so-stkHistTopUpRow td {\n  padding: 14px !important;\n  background: #fafafa;\n  vertical-align: middle !important;\n  border-bottom: 1px solid #f0f0f0 !important;\n}\n\n.so-stkHistTopUpRow:last-of-type td {\n  border-bottom: 1px solid #f0f0f0 !important;\n  padding-bottom: 16px !important;\n}\n\n.so-stkTopUpHistory {\n  background: #fff;\n  border: 1px solid #eaecef;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.so-stkTopUpHistory__title {\n  padding: 12px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #1e2329;\n  border-bottom: 1px solid #f0f0f0;\n  background: #f9fafb;\n}\n\n.so-stkTopUpHistory__card {\n  padding: 4px 0;\n  border-bottom: 1px solid #f0f0f0;\n}\n\n.so-stkTopUpHistory__card:last-child {\n  border-bottom: none;\n}\n\n.so-stkTopUpHistory--mobile {\n  margin-top: 12px;\n}\n\n.so-stkHistMobileCard--expandable .so-stkHistMobileType--clickable {\n  cursor: pointer;\n}\n\n.so-stakingCoin {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.so-stakingCoin__icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  object-fit: cover;\n  flex-shrink: 0;\n}\n\n.so-stakeProtocol {\n  color: #00a63e;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n}\n\n.so-stakeType {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0px;\n  border-radius: 999px;\n  font-size: 16px;\n  font-weight: 500;\n  line-height: 1.2;\n  white-space: nowrap;\n}\n\n.so-stakeType--flexible {\n  color: #1f9e5e;\n}\n\n.so-stakeType--locked {\n  color: #b45309;\n}\n\n.so-tableWrap--staking {\n  min-height: 320px;\n}\n\n.so-table.so-table--staking {\n  min-width: 860px;\n}\n\n.so-table.so-table--convert {\n  min-width: 920px;\n}\n\n.so-convertSpend {\n  color: #EF4444;\n  font-weight: 400;\n}\n\n.so-convertReceive {\n  color: #10B981;\n  font-weight: 400;\n}\n\n.so-table.so-table--copyTrading {\n  min-width: 1280px;\n}\n\n.so-tableWrap--copyTrading {\n  min-height: 300px;\n}\n\n.so-copyExitCell {\n  display: flex;\n  align-items: flex-end;\n  gap: 2px;\n}\n\n.so-table.so-table--staking tbody td.so-table__emptyWrap,\n.so-table.so-table--convert tbody td.so-table__emptyWrap,\n.so-table.so-table--copyTrading tbody td.so-table__emptyWrap,\n.so-table.so-table--wide tbody td.so-table__emptyWrap {\n  padding: 48px 24px !important;\n  text-align: center;\n  vertical-align: middle;\n  border-bottom: none !important;\n}\n\n.so-emptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  min-height: 260px;\n  padding: 16px 0;\n}\n\n.so-emptyState--mobile {\n  min-height: 220px;\n  margin-top: 8px;\n  padding: 32px 16px 48px;\n  border-radius: 12px;\n}\n\n.so-emptyState__img {\n  display: block;\n  width: 120px;\n  height: auto;\n  max-height: 160px;\n  object-fit: contain;\n  filter: invert(1);\n}\n\nbody.light_theme .so-emptyState__img {\n  filter: invert(0);\n}\n\n.so-emptyState__caption {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 500;\n  color: #98a2b3;\n}\n\n@media (max-width: 1440px) {\n\n  .so-toolbar .so-toolbar__left {\n    width: 70%;\n    overflow: scroll;\n  }\n\n}\n\n\n@media (max-width: 1200px) {\n\n  .so-toolbar--stack .so-toolbar__left,\n  .so-toolbar--stack .so-toolbar__right {\n    flex-wrap: wrap;\n  }\n\n\n  .so-stakeType {\n    font-size: 13px;\n  }\n\n  .so-mobileCard__statusLabel {\n    font-size: 13px;\n  }\n\n  .so-toolbar__left {\n    gap: 12px;\n  }\n\n  .so-toolbar .so-toolbar__left {\n    width: 100%;\n  }\n\n}\n\n@media (max-width: 991px) {\n\n  .so-mobile__title {\n    display: none;\n  }\n\n  .orders-mrp__panel.orders-mrp__panel--light .so-mobileCard__statusLabel {\n    font-size: 14px;\n    color: #707a8a;\n  }\n\n  .orders-mrp__panel.orders-mrp__panel--light .so-cancelBtn {\n    font-size: 14px;\n  }\n\n  .so-mobile .so-subtabs {\n    padding: 0px 0 0;\n    margin: 0 0 10px;\n    border-bottom: none;\n  }\n\n  .so-mobile .so-subtabsWrap {\n    padding: 0px;\n    /* room for arrows */\n  }\n\n  .so-dd__menu--inline {\n    position: absolute;\n    top: 64px;\n  }\n\n  .so-mobile .so-subtabsArrow {\n    display: inline-flex;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    align-items: center;\n    justify-content: center;\n    padding: 0px;\n    height: 24px;\n    border: none;\n    border-radius: 0px !important;\n    background: #fff;\n    color: #101828;\n    border-radius: 999px;\n  }\n\n  .so-mobile .so-subtabsArrow i {\n    font-size: 18px;\n    line-height: 1;\n  }\n\n  .so-mobile .so-subtabsArrow--left {\n    left: 0;\n  }\n\n  .so-mobile .so-subtabsArrow--right {\n    right: 0;\n  }\n\n  .so-mobile .so-subtabsArrow.is-hidden {\n    display: none;\n  }\n\n  .so-mobile {\n    margin-top: -12px;\n  }\n\n  .so-dd__menu--inline {\n    margin-top: 0px;\n  }\n\n}\n\n@media (max-width:767px) {\n\n  .so-stkActionBtn {\n    padding: 0 10px;\n    font-size: 12px;\n  }\n\n  .so-mobileCard .so-stkActionCell {\n    flex-wrap: wrap;\n    justify-content: end;\n  }\n\n  .so-cancelBtn {\n    font-size: 13px;\n  }\n\n}\n\n\n@media (max-width: 640px) {\n  .so-page {\n    padding: 20px 16px 32px;\n  }\n\n  .so-page__title {\n    font-size: 26px;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__left,\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {\n    width: 100%;\n  }\n\n  .so-toolbar:not(.so-toolbar--stack) .so-toolbar__right {\n    justify-content: flex-start;\n  }\n\n  .so-dd,\n  .so-dateBlock {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .so-subtabs__tab {\n    font-size: 15px;\n  }\n\n  .so-dd__trigger {\n    width: 100%;\n    min-width: 0;\n  }\n\n  .so-toolbar--stack .so-goStakingBtn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n/*\n * Profile `/user_profile/orders/spot_*`: global style.css switches table vs cards at 1367px\n * viewport, while the profile rail uses 992px — narrow desktop can hide both or show the wrong\n * column. Force open-orders / order-history / trade-history mobile cards at ≤991px so the\n * same React `rows` as the table are visible on phones.\n */\n@media (max-width: 991.98px) {\n  .dashboard_right .dashboard_listing_section2.Overview_mid .listing_left_outer.full_width.transaction_history_t.desktop_view2.so-desktopWrap {\n    display: none !important;\n  }\n\n  .dashboard_right .dashboard_listing_section2.Overview_mid .order_history_mobile_view.so-mobile {\n    display: block !important;\n    width: 100%;\n  }\n}\n\n/* —— Orders → Deposit History (same API rows as asset Deposit page) —— */\n.so-depHist_actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  max-width: 100%;\n  min-width: 0;\n}\n\n.so-depHist_actions--wrap {\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.so-depHist_trunc {\n  min-width: 0;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.so-depHist_iconBtn {\n  display: inline-flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  border-radius: 8px;\n  border: 1px solid rgba(148, 163, 184, 0.45);\n  background: #f8fafc;\n  color: #334155;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n  padding: 0;\n  line-height: 1;\n}\n\n.so-depHist_iconBtn:hover {\n  background: #eef2ff;\n  border-color: rgba(99, 102, 241, 0.55);\n  color: #3730a3;\n}\n\n.so-depHist_iconBtn--link {\n  text-decoration: none;\n}\n\n.so-depHist_badge {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 6px 10px;\n  border-radius: 999px;\n  font-size: 12px;\n  font-weight: 700;\n  border: 1px solid transparent;\n  white-space: nowrap;\n  line-height: 1;\n  text-transform: capitalize;\n}\n\n.so-depHist_badge.is-success {\n  background: #ecfdf3;\n  border-color: #a7f3d0;\n  color: #067647;\n}\n\n.so-depHist_badge.is-pending {\n  background: #fffbeb;\n  border-color: #fde68a;\n  color: #92400e;\n}\n\n.so-depHist_badge.is-danger {\n  background: #fef2f2;\n  border-color: #fecaca;\n  color: #b42318;\n}\n\n.so-depHist_badge.is-info {\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n\n.so-depHist_badge.is-neutral {\n  background: #f1f5f9;\n  border-color: #e2e8f0;\n  color: #334155;\n}\n\nbody:not(.light_theme) .so-depHist_iconBtn {\n  background: #1f2937;\n  border-color: rgba(148, 163, 184, 0.35);\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .so-depHist_iconBtn:hover {\n  background: rgba(59, 130, 246, 0.18);\n  border-color: rgba(59, 130, 246, 0.45);\n  color: #bfdbfe;\n}\n\nbody:not(.light_theme) .so-depHist_badge.is-neutral {\n  background: rgba(148, 163, 184, 0.12);\n  border-color: rgba(148, 163, 184, 0.22);\n  color: #e2e8f0;\n}\n\nbody:not(.light_theme) .so-depHist_badge.is-success {\n  background: rgba(16, 185, 129, 0.15);\n  border-color: rgba(16, 185, 129, 0.35);\n  color: #6ee7b7;\n}\n\nbody:not(.light_theme) .so-depHist_badge.is-pending {\n  background: rgba(245, 158, 11, 0.15);\n  border-color: rgba(245, 158, 11, 0.35);\n  color: #fcd34d;\n}\n\nbody:not(.light_theme) .so-depHist_badge.is-danger {\n  background: rgba(239, 68, 68, 0.15);\n  border-color: rgba(239, 68, 68, 0.35);\n  color: #fca5a5;\n}\n\nbody:not(.light_theme) .so-depHist_badge.is-info {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.35);\n  color: #93c5fd;\n}\n\n.so-filtersModal .btn-close {\n  filter: invert(1) grayscale(100%) brightness(200%);\n}\n\nbody.light_theme .so-filtersModal .btn-close {\n  filter: none;\n}\n\n.so-filtersModal .funding-account__check {\n  color: #EAECEF;\n}\n\nbody.light_theme .so-filtersModal .funding-account__check {\n  color: #4A5565;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
